import { css } from 'aphrodite';
import * as React from 'react';
import { XIcon } from '../../../web/components/svgs/icons/XIcon';
import { white } from '../../styles/colors';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	onClick: () => void;
}

export const MrryCloseButton: React.FC<IProps> = ({ className = '', onClick }) => {
	return (
		<button className={`${css(styleSheet.mrryCloseButton)} ${className}`} onClick={onClick}>
			<XIcon color={white} height={12} width={12} />
		</button>
	);
};
